// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'ddj-license-spinner',
    templateUrl: './ddj-license-spinner.component.html',
    styleUrls: ['./ddj-license-spinner.component.scss'],
})
export class DdjLicenseSpinnerComponent implements OnInit {
    @Input()
    phraseOverrides: string[] = [];

    private get phrases() {
        const defaultPhrases = [
            'Uploading image to the secure vault has begun',
            'Image processing in progress',
            'Saving image to the secure vault',
            'Image saving almost complete',
            'Confirming image has been saved successfully',
        ];
        for (let i = 0; i < defaultPhrases.length; i++) {
            if (this.phraseOverrides[i]) {
                defaultPhrases[i] = this.phraseOverrides[i];
            }
        }
        return defaultPhrases;
    }

    constructor() {}

    ngOnInit(): void {
        this.changePhrase(this.phrases);
    }

    changePhrase(arr) {
        const phrase = document.getElementById('phrase');
        for (let i = 0; i < arr.length; i++) {
            // for each iteration console.log a word
            // and make a pause after it

            (function (i) {
                setTimeout(function () {
                    if (arr[i].length <= 0) {
                        arr = [''];
                    } else {
                        phrase.innerHTML = arr[i];
                    }
                }, 2500 * i);
            })(i);
        }
    }
}
